import { render, staticRenderFns } from "./VsPaginationModified.vue?vue&type=template&id=cf3cef14&scoped=true&"
import script from "./VsPaginationModified.vue?vue&type=script&lang=js&"
export * from "./VsPaginationModified.vue?vue&type=script&lang=js&"
import style0 from "./VsPaginationModified.vue?vue&type=style&index=0&id=cf3cef14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3cef14",
  null
  
)

export default component.exports